import { Injectable } from "@angular/core";
import { CitronellaImg } from "../models/ExternalAPI/CitronellaImg";
import { CitronellaImgDataResponse } from "../models/ExternalAPI/CitronellaImgDataResponse";

@Injectable({
  providedIn: "root",
})
export class ImageCacheService {
  dataDummy: CitronellaImgDataResponse = {
      Name: "1145_250526_122302.png",
      ContentType: "image/png",
      Md5: "PIWEmEsxOz00pVEhn+/N7g==",
      SignedUrl:
        "https://storage.googleapis.com/unilever.test.einteligent.com/1%2F1%2FTickets%2F1145%2F32a90073-0793-4b01-b5aa-77c844331b4d.png?GoogleAccessId=functions-hyperion@storage-test-253501.iam.gserviceaccount.com&Expires=1754786851&Signature=C7KXwZyi5hOE%2B7AVXj0cd4k5uBY8U40CRnwOs7mWVTQUbx%2Bzxh73bUKr6qwbup1bcZxj5ejRbuiWioyAPRkK%2FDdeDn5CPPBaDl3cPFrzeWJIfYa9O5fbXoRL008O2OLMJLqlpyxHmTPWlx4D0s6aiXRW%2Bm5dcUJgaTAeUqiPSuXcFtrOhfmhcJnItr68%2ByAY34zJD2kEJVNtd4gLIVgVILRL8reQBx94SsaLQujoBCuf%2FJD5uokOXY%2FeapCiWWNk3%2FNZm17QweOZUPFD7MByO8Ge0oA6Ls0Q6srXaKlCbkMAkyZdMtfaVpb81EpnNxbQiBsSpqYOVS8eCSb52L5C7A%3D%3D",
    };

    
  public isReloading: boolean = false;
  public viewDesencriptado: any = [];

  private mapixImageCache: { [name: string]: string } = {};
  private citronellaImageCache: CitronellaImg[] = [];

  setAllMapixImages() {
    const urlList = JSON.parse(localStorage.getItem("UrlList") || "[]");
    if (!!urlList) {
      urlList.forEach((item: { name: string; url: string }) => {
        if(this.mapixImageCache[item.name]) {
          console.log(`La imagen ${item.name} ya está en caché.`);
        } else {
          fetch(item.url)
            .then((res) => res.blob())
            .then((blob) => {
              const reader = new FileReader();
              reader.onload = () => {
                this.setMapixImage(item.name, reader.result as string);
              };
              reader.readAsDataURL(blob);
            });
        }
      });
      //console.log(`Imagenes cargadas: ${urlList.length}`, this.mapixImageCache);
    }
  }

  setMapixImage(name: string, dataUrl: string) {
    this.mapixImageCache[name] = dataUrl;
  }

  getMapixImage(name: string): string | undefined {
    return this.mapixImageCache[name];
  }

  hasMapixImage(name: string): boolean {
    return !!this.mapixImageCache[name];
  }

  isMapixImagesEmpty(): boolean {
    return Object.keys(this.mapixImageCache).length === 0;
  }

  // citronella
  async setCitronellaImageBase64(citronellaImgData: CitronellaImgDataResponse, identifier: string) {
    try {
      const response = await fetch(citronellaImgData.SignedUrl, {
        method: "GET",
        headers: {
          "Content-Type": citronellaImgData.ContentType,
          "Content-MD5": citronellaImgData.Md5,
        }
      });
  
      const blob = await response.blob();
  
      const imageUrl = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result as string);
        };
        reader.onerror = () => {
          reject(reader.error);
        };
        reader.readAsDataURL(blob);
      });
  
      const citronellaImage: CitronellaImg = {
        Identifier: identifier,
        Name: citronellaImgData.Name,
        Url: imageUrl,
      };
      this.citronellaImageCache.push(citronellaImage);
    } catch (error) {
      console.error("Error cargando imagen:", error);
    }
  }

  getCitronellaImagesByIdentifier(identifier: string): string[] {
    var images = [];
    this.citronellaImageCache.forEach((cache) => {
      if (cache.Identifier === identifier) {
        images.push(cache.Url);
      }
    });
    // var images = this.citronellaImageCache.filter((img) => img.Identifier == identifier);
    // console.log(`Obteniendo imag filter: ${identifier}`, this.citronellaImageCache, images);
    return images.length > 0 ? images : [];
  }

  hasCitronellaImageByIdentifier(identifier: string): boolean {
    return this.citronellaImageCache.some((img) => img.Identifier === identifier);
  }

  getCitronellaImageByName(name: string): string {
    const image = this.citronellaImageCache.find((img) => img.Name === name);
    return image ? image.Url : undefined;
  }

  hasCitronellaImageByName(name: string): boolean {
    return this.citronellaImageCache.some((img) => img.Name === name);
  }

  isCitronellaImagesEmpty(): boolean {
    return this.citronellaImageCache.length === 0;
  }

  emptyCitronellaImagesByIdentifier(identifier: string) {
    this.citronellaImageCache = this.citronellaImageCache.filter((img) => img.Identifier !== identifier);
  }


  // -----------
  clearImageCache(){
    this.mapixImageCache = {};
    this.citronellaImageCache = [];
    console.log("Cache cleared");
  }
}
